export const sortFieldOptions = [
    { value: 'productnr', label: 'Productnr' },
    { value: 'ordernr', label: 'Ordernr' },
    { value: 'customer', label: 'Klant' },
    { value: 'reference', label: 'Referentie' },
    { value: 'producttype', label: 'Producttype' },
    { value: 'ralnr', label: 'Ralnr' },
    { value: 'raltype', label: 'Raltype' },
    { value: 'poedernr', label: 'Poedernummer' },
    { value: 'status', label: 'Status' },
    { value: 'deliveryDateIN', label: 'Leveringsdatum IN' },
    { value: 'deliverydate', label: 'Leveringsdatum UIT' },
    { value: 'originaldeliverydate', label: 'Originele leveringsdatum' },
    { value: 'deliverydateid', label: 'Ritnr' },
    { value: 'deliverymethod', label: 'Leveringsmethode' },
    { value: 'supplierId', label: 'Leverancier' },
];

export const sortOrderOptions = [
    { value: 'ASC', label: 'Oplopend' },
    { value: 'DESC', label: 'Aflopend' },
];

export const emptinessOptions = [
    { value: 'ALL', label: 'Alle' },
    { value: 'NOT_EMPTY', label: 'Niet leeg' },
];

export const specialFilterOptions = [
    { value: 'noFilter', label: 'Geen filter' },
    { value: 'pastDueFilter', label: 'In buffertijd' },
    { value: 'recalculatedFilter', label: 'Aangepaste leverdatum' },
    { value: 'finishedFilter', label: 'Toon ook afgewerkte producten' },
    { value: 'eosolFilter', label: 'Groothandel klanten' },
    { value: 'mmFilter', label: 'Particuliere klanten' },
];

export const fixedSupplierEditOptions = [{ label: '', value: null }];

export const fixedSupplierOptions = [
    { label: 'Alle leveranciers', value: -1 }, //Show all
    { label: '', value: 0 }, //Null in database
];

export function generateSupplierOptions(suppliers, fixedOptions) {
    if (!suppliers) {
        return null;
    }
    return [
        ...fixedOptions,
        ...suppliers.map((x) => ({
            value: x.id,
            label: x.name,
        })),
    ];
}

export const clearedFilters = {
    producttype: '',
    productnr: '',
    ordernr: '',
    customer: '',
    reference: '',
    ralnr: '',
    raltype: '',
    poedernr: '',
    status: '',
    deliveryDateId: '',
    deliveryDate: '',
    deliveryDateIN: '',
    originaldeliveryDate: '',
    deliveryMethod: '',
    finished: false,
    supplierId: -1, //Show all
    sortField: sortFieldOptions[10].value,
    sortOrder: sortOrderOptions[0].value,
    sortEmpty: emptinessOptions[0].value,
    specialFilter: specialFilterOptions[0].value,
};
